import React from 'react';
import './LoadingSkeleton.css';

export const LoadingPlaceholder = ({ message = "Loading..." }) => (
  <div className="loading-placeholder">
    <p>{message}</p>
  </div>
);

export const ContentWrapper = ({ isLoading, children, loadingMessage = "Loading..." }) => (
  <div className={isLoading ? 'content-loading' : 'content-loaded fade-in'}>
    {isLoading ? (
      <LoadingPlaceholder message={loadingMessage} />
    ) : (
      children
    )}
  </div>
);